import { html, ref, repeat, when } from '@microsoft/fast-element';
import { getPrefix } from '../utils';
export const menuTemplate = (prefix) => html `
  <${prefix}-button
    id="actiosnMenuTrigger"
    class="actions-opener${(x) => (x.open ? ' opened' : '')}"
    appearance="${(x) => x.buttonAppearance}"
    part="actions-opener"
    @click=${(x) => x.toggleActionsMenuVisibility()}
  >
    ${(x) => x.open
    ? '✖'
    : html `
            ${x.name}
          `}
  </${prefix}-button>
  <${prefix}-menu ${ref('actionsMenu')} class="actions-menu ${(x) => x.classNames}" part="actions-menu">
    ${repeat((x) => x.allActions, html `
        ${when((x, context) => x.isDisabled && x.isDisabled(context.parent.rowData), html `
            <${prefix}-menu-item
              class="menu-item"
              tabindex="${(x, context) => context.index}"
              disabled
              style=${(x, ctx) => (ctx.parent.hideDisabled ? 'display:none' : '')}
            >
              ${(x, ctx) => ctx.parent.getLabel(x.name)}
            </${prefix}-menu-item>
          `)}
        ${when((x, context) => !x.isDisabled || !x.isDisabled(context.parent.rowData), html `
            <${prefix}-menu-item
              class="menu-item"
              tabindex="${(x, context) => context.index}"
              @click=${(x, context) => context.parent.onActionMenuItemClick(x.callback)}
              style="${(x) => (x.color ? `color: ${x.color};` : '')}"
            >
              ${(x, ctx) => ctx.parent.getLabel(x.name)}
            </${prefix}-menu-item>
          `)}
      `, { positioning: true })}
  </${prefix}-menu>
`;
export const singleOptionTemplate = (prefix) => html `
  <${prefix}-button
    appearance="${(x) => x.buttonAppearance}"
    part="actions-opener"
    class="actions-opener"
    @click=${(x) => {
    return x === null || x === void 0 ? void 0 : x.singleOption.callback(x.rowData);
}}
    ?disabled=${(x) => {
    return (x === null || x === void 0 ? void 0 : x.singleOption.isDisabled) && (x === null || x === void 0 ? void 0 : x.singleOption.isDisabled(x.rowData));
}}
  >
    ${(x) => x.getLabel(x === null || x === void 0 ? void 0 : x.singleOption.name)}
  </${prefix}-button>
`;
export const foundationActionsMenuTemplate = html `
  <div
    class="actions-container${(x) => (x.isVertical ? ' actions-vertical' : '')}"
    part="actions-container"
  >
    ${(x) => x.getTemplate(getPrefix(x))}
  </div>
`;
